export const DEV_SIMILARITY_FLAG_KEY = "statsfan:devSimilarity";
export const DEV_SIMILARITY_MODEL_KEY = "statsfan:similarityModel";

/** Enable in DevTools: localStorage.setItem("statsfan:devSimilarity", "1")
 *  then localStorage.setItem("statsfan:similarityModel", "v2-experimental")
 */

export function resolveDevSimilarityModel(storage) {
  const store = storage || (typeof localStorage === "undefined" ? null : localStorage);
  if (!store?.getItem) return undefined;
  if (store.getItem(DEV_SIMILARITY_FLAG_KEY) !== "1") return undefined;
  const model = store.getItem(DEV_SIMILARITY_MODEL_KEY);
  if (!model || model === "v1") return undefined;
  return model;
}
